export class FetchDeviceListRequestBody {
    private uid: string;
  
    constructor(uid: string) {
      this.uid = uid
    }
}

export class InstallGadgetOnDeviceBody {
  private uid: string;
  private gadgetURL: string;
  private devices: string[];
  private sizeInBytes: number;
  private gadgetId: number;

  constructor(uid: string, gadgetURL: string, devices: string[], sizeInBytes: number, gadgetId: number) {
    this.uid = uid;
    this.gadgetURL = gadgetURL;
    this.devices = devices;
    this.sizeInBytes = sizeInBytes;
    this.gadgetId = gadgetId;
  }
}